import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MenuItem} from 'primeng/api';
import {ActivatedRouteSnapshot, Data, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

interface Breadcrumb {
    label: string;
}

@Injectable()
export class BreadcrumbService {

    private itemsSource = new BehaviorSubject<MenuItem[]>([]);

    itemsHandler = this.itemsSource.asObservable();

    constructor(private router: Router) {
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd)
        ).subscribe(event => {

            // Construct the breadcrumb hierarchy
            const root = this.router.routerState.snapshot.root;
            const breadcrumbs: Breadcrumb[] = [];
            this.addBreadcrumb(root, [], breadcrumbs);

            const snapshot = this.router.routerState.snapshot;

            this.itemsSource.next(breadcrumbs);
        });
    }

    setItems(items: MenuItem[]) {
        this.itemsSource.next(items);
    }

    setLastItem(name: string) {
        const items = this.itemsSource.getValue();
        const item = items[items.length - 1];
        item.label = name;
        const value = [...items];
        // console.log('setLastItem', value);
        this.itemsSource.next(value);
    }

    private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
        // console.log('addBreadcrumb', {route, parentUrl, breadcrumbs});
        if (route) {
            // Construct the route URL
            const routeUrl = parentUrl.concat(route.url.map(url => url.path));
            // console.log({routeUrl}, route.data.breadcrumb);

            // Add an element for the current route part
            if (route.data.breadcrumb) {
                const breadcrumb = {
                    label: this.getLabel(route.data),
                    url: '/' + routeUrl.join('/')
                };
                breadcrumbs.push(breadcrumb);
            }

            // Add another element for the next route part
            this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
        }
    }

    private getLabel(data: Data) {
        // The breadcrumb can be defined as a static string or as a function to construct the breadcrumb element out of the route data
        return typeof data.breadcrumb === 'function' ? data.breadcrumb(data) : data.breadcrumb;
    }

}
